export const showAddGdprModal = () => {
    return {
      type: "SHOW_ADD_GDPR_MODAL",
    };
  };
  
  export const hideAddGdprModal = () => {
    return {
      type: "HIDE_ADD_GDPR_MODAL",
    };
  };
  